var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkAccess('invoices'))?_c('report-list-page',{attrs:{"page-title":"Invoice Report","page-icon":"transform","status-arr":_vm.statusArr,"descending":true,"headers":_vm.headers,"state-end-point":"invoice.invoices","actions":_vm.actions,"show-component":_vm.showComponent}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }